/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
// Material UI
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

function ContentListItemImageHeader({ instance }) {
  return (
    <>
      <CardMedia
        className="h-160"
        title={instance.title}
        image={`${window.location.origin.toString()}/assets/images/courses/${instance.language.acronym.toUpperCase()}.jpg`}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 80,
          left: 0,
          height: 80,
          width: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            bgcolor: 'transparent',
            color: 'white',
            padding: '32px 16px'
          }}
        >
          <img
            className="m-0 mb-4 min-w-20"
            src={`${window.location.origin.toString()}/assets/images/flags/${instance.language.acronym.toUpperCase()}.svg`}
            alt={`${instance.language.title} flag`}
          />
          <Typography className="text-16 font-medium">
            {instance.title}
          </Typography>
          <Typography className="text-13 mt-2 line-clamp-2">
            {instance.label}
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export default ContentListItemImageHeader;
